import { render, staticRenderFns } from "./FormDivTextarea.vue?vue&type=template&id=cfc5a99e&scoped=true&"
import script from "./FormDivTextarea.vue?vue&type=script&lang=js&"
export * from "./FormDivTextarea.vue?vue&type=script&lang=js&"
import style0 from "./FormDivTextarea.vue?vue&type=style&index=0&id=cfc5a99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc5a99e",
  null
  
)

export default component.exports